import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, Params, NavigationEnd } from "@angular/router";
import { environment } from "../environments/environment";
import { AuthWebService } from "../app/services/authweb.service";
import { StorageService } from "./services/storage.service";
import { UtilityServiceService } from "./services/utility-service.service";
import { CarriertransactionService } from "./services/carriertransaction.service";
//import { PreBootService } from './services/preboot.service'; //!important - Do Not move

import { Keepalive } from "@ng-idle/keepalive";
import { BsModalService, ModalDirective } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
//import { ModalDirective } from 'ngx-bootstrap/modal';
import { IdleManagerService } from "app/services/idle-manager.service";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { PopupService } from "./services/shared/popup.service";
import { SignalrService } from "./services/signalr.service";
import { AuthSession } from "./interfaces/authsession.interface";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { SocialAuthService, SocialUser } from "angular12-social-login";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  public ftitle = "";
  @Input("ctrlData") ctrlData: any = {
    carrierId: 0,
    isApproval: false,
    currentActive: 1,
    action: 0,
    ctrlAction: 0,
    data: {},
  };
  enableClass: boolean = true;
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  userIdleTime = 5;
  isSanralRole: boolean = false;
  userTimeOut = 10;
  sessionId: string;
  isKiosk = false;
  auth2: any;
  routeDetials;
  public modalRef: BsModalRef;
  @ViewChild("childModal", { static: true }) childModal: ModalDirective;
  ipAddress: any;

  constructor(
    public authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
    private storageSvc: StorageService,
    private msgService: PopupService,
    public utility: UtilityServiceService,
    private signalrService: SignalrService,
    private idle: Idle,
    private documentService: DocumentsServiceService,
    private keepalive: Keepalive,
    private modalService: BsModalService,
    private idleSrvc: IdleManagerService,
    private authService: SocialAuthService,
    private _route: Router
  ) {
    this.setIdleSettings();

    // this.signalrService.getIpAddres();
  }

  user: SocialUser;
  loggedIn: boolean;

  ngOnInit() {
    let currentUrl: any = "";
    let previousUrl: any = "";
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        previousUrl = currentUrl;
        if (previousUrl != "") {
          setTimeout(() => {
            localStorage.setItem("previousUrl", previousUrl);
            sessionStorage.setItem("previousUrl", previousUrl);
          }, 200);
        }
        currentUrl = e.url;
        if (this.authWebService.userData.Roles[0].Name=='Sanral Staff') {
          this.isSanralRole = true;
        }
        if (e.url.indexOf("/permit/application") > 0) {
          this.enableClass = false;
        } else {
          this.enableClass = true;
        }
      }
    });

    this.getSystemConfig();
    this.checkIfUserLoggedIn();
    //When session is closed logout
    console.dir("LoginID", sessionStorage.getItem("loginID"));
    if (
      localStorage.getItem("userID") !== null &&
      sessionStorage.getItem("loginID") === null
    ) {
      this.authWebService.logout();
    }

    this.checkIfKiosk();
    // this.googleAuthSDK();
  }

  receiveTransData($event) {}

  getSystemConfig() {
    this.authWebService.SystemConfig().subscribe(
      (data) => {
        environment.authWebApi.systemData = data;
        const footer = environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "MainFooter"
        );
        if (footer) {
          this.ftitle = footer.Value;
        } else {
          this.ftitle = "iCBMS";
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  checkIfKiosk() {
    this.documentService.checkIfKiosk().subscribe(
      (res: any) => {
        this.isKiosk = true;

        this.runSignalRService();

        try {
          this.signalrService.getPCDetails().subscribe((result: any) => {
            console.log("GET PC DETAILS", result);
            this.signalrService.machinename = result.pcName;
            this.signalrService.ipAddress = result.ipAddress;
          });
        } catch (e) {
          console.error(e);
        }
      },
      (err) => {}
    );
  }

  runSignalRService() {
    if (localStorage.getItem("userID") === null) {
      return;
    }

    if (localStorage.getItem("sessionId") != null) {
      this.sessionId = localStorage.getItem("sessionId").toString();
    } else {
      this.sessionId = crypto.randomUUID();
      localStorage.setItem("sessionId", this.sessionId);
    }

    let authSession: AuthSession = {
      id: 0,
      carrierId: 0,
      sessionId: this.sessionId,
      pcIpAddress: this.signalrService.ipAddress,
      pcName: "",
      statusId: 1,
      connectionId: this.signalrService.connectionId,
      sessionStartTime: new Date(),
      sessionEndTime: new Date(),
      dateCreated: new Date(),
      dateModified: new Date(),
      userCreated: localStorage.getItem("userID"),
      userModifiedId: Number(localStorage.getItem("userID")),
    };

    this.signalrService.SessionManager(authSession);
  }

  public googleAuthSDK() {
    (<any>window)["googleSDKLoaded"] = () => {
      (<any>window)["gapi"].load("auth2", () => {
        this.auth2 = (<any>window)["gapi"].auth2.init({
          client_id:
            "42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com",
          plugin_name: "login",
          cookiepolicy: "single_host_origin",
          scope: "profile email",
        });

        // this.callLogin();
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement("script");
      js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs?.parentNode?.insertBefore(js, fjs);
    })(document, "script", "google-jssdk");
  }

  activate(email) {
    //console.log( this.authWebService.activateAccout(email));
    // this.authWebService.activateAccout(email)
  }

  checkIfUserLoggedIn = () => {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.utility.isView = true;
        this.utility.showstatementfooter = false;
        let url =
          this.router.url.indexOf("?") !== -1
            ? this.router.url.substring(0, this.router.url.indexOf("?")).trim()
            : this.router.url;
        this.routeDetials = this._route.url.split("/")[5];
        switch (url) {
          case "/activate": {
            const firstNum = this.router.url.indexOf("=");
            // //console.log(this.router.url.substring(firstNum + 1))
            // if (this.router.url.substring(firstNum + 1).includes('@')) {
            //   //console.log('in get email '+this.router.url.substring(firstNum + 1))
            //   this.activate(this.router.url.substring(firstNum + 1))
            //  // localStorage.setItem('activeEmail', this.router.url.substring(firstNum + 1))
            // }
            this.router.navigate([
              "activate",
              this.router.url.substring(firstNum + 1),
            ]);

            break;
          }
          case "/register": {
            this.router.navigate(["register"]);
            break;
          }

          case "/reset": {
            this.router.navigate(["reset"]);

            break;
          }

          case "/reset/confirm": {
            this.router.navigate(["reset/confirm"]);
            break;
          }

          // default:{
          //   if (this.authWebService.authenticated != true) { this.router.navigate(['login']); }

          //   break;

          // }
        }
      }
    });
  };

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  hideChildModal(): void {
    this.childModal.hide();
  }

  stay() {
    this.childModal.hide();
    this.reset();
  }

  logout() {
    console.log("Tryting to Logout");
    this.authService.signOut();
    this.childModal.hide();
    this.idleSrvc.setLoggedIn(false);
    this.authWebService.logout();
    var cookies = document.cookie.split(";");
    console.log("Cookies");
    console.log(cookies);
  }

  setIdleSettings = () => {
    this.authWebService.getUserTimeout().subscribe((data) => {
      this.userIdleTime = +data;
      this.userIdleTime = this.userIdleTime * 60;
      if (this.userIdleTime > 0) {
        this.idle.setIdle(this.userIdleTime);
        this.idle.setTimeout(this.userTimeOut);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleEnd.subscribe(() => {
          this.idleState = "No longer idle.";
          this.reset();
        });

        this.idle.onTimeout.subscribe(() => {
          this.childModal.hide();
          this.idleState = "Timed out!";
          this.timedOut = true;
          this.authWebService.logout();
        });

        this.idle.onIdleStart.subscribe(() => {
          this.idleState = "You've gone idle!";
          this.childModal.show();
        });

        this.idle.onTimeoutWarning.subscribe((countdown) => {
          let s = countdown > 1 ? "s!" : "!";
          this.idleState =
            "You will be logged out in " + countdown + ` second${s}`;
        });

        // sets the ping interval to 15 seconds
        this.keepalive.interval(15);

        this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

        this.idleSrvc.getLoggedIn().subscribe((userLoggedIn) => {
          if (userLoggedIn) {
            this.idle.watch();
            this.timedOut = false;
          } else {
            this.idle.stop();
          }
        });
      } else {
        this.idleSrvc.setLoggedIn(false);
      }
    });
  };
}
